/**
 * Create a function which will call the callback function
 * after the given amount of milliseconds has passed since
 * the last time the callback function was called.
 */
export const idle = (callback, delay) =>
{
	let handle;

	return () =>
	{
		if (handle)
		{
			clearTimeout(handle);
		}

		handle = setTimeout(callback, delay);
	};
};

/**
 * Error produced when a socket request has a timeout.
 */
export class SocketTimeoutError extends Error
{
	constructor(message)
	{
		super(message);

		this.name = 'SocketTimeoutError';

		if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
			Error.captureStackTrace(this, SocketTimeoutError);
		else
			this.stack = (new Error(message)).stack;
	}
}

export const validateCharecters = (data) =>
{
	const re = /^([a-zA-Z ]+)$/;

	return re.test(data);
};

export const validateNumber = (data) =>
{
	const re = /^([0-9]+)$/;

	return re.test(data);
};

export const validateEmail = (data) =>
{
	const re = /^((([a-zA-Z]|[0-9])|([-]|[_]|[.])){1,})+[@](([a-zA-Z0-9])|([-]|[.])){2,40}[.]((([a-zA-Z0-9]){2,10})|(([a-zA-Z0-9]){2,4}[.]([a-zA-Z0-9]){2,4}))$/;

	return re.test(data);
};

export const validatePassword = (data) =>
{
	const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;

	return regex.test(data);
};

export const validateIsNotempty = (data) =>
{
	return data && data.trim() !== '';
};

export const querystring = (name, url = window.location.href) =>
{
	name = name.replace(/[[]]/g, '\\$&');

	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');

	const results = regex.exec(url);

	if (!results)
	{
		return null;
	}
	if (!results[2])
	{
		return '';
	}

	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const dateFormat = (date) =>
{
	return new Date(date).toLocaleString('en-US', {
		month : 'short',
		day   : '2-digit',
		year  : 'numeric'
	});
};

export const datetimeFormat = (date) =>
{
	return new Date(date).toLocaleString('en-US', {
		day    : '2-digit',
		month  : '2-digit',
		year   : 'numeric',
		hour   : '2-digit',
		minute : '2-digit',
		hour12 : true
	});
};

export const timeFormat = (date) =>
{
	return new Date(date).toLocaleString('en-US', {
		hour   : '2-digit',
		minute : '2-digit',
		hour12 : true
	});
};

export const getDuration = (min) =>
{
	if (min < 60)
	{
		return `${min} Mins`;
	}
	else if (min === 60)
	{
		return '1 Hour';
	}
	else
	{
		const h = Math.floor(min/60);

		const m = min%60;

		let res = h > 1 ? `${h} Hours` : `${1} Hour`;

		res += m > 0 ? ` ${m} Mins` : '';

		return res;
	}
};

export const diffrenceInDays = (d1, d2) =>
{
	return Math.ceil((d2 - d1)/(1000 * 60 * 60 * 24));
};